export default __webpack_public_path__ + "static/media/game-1.bacbb355.jpg";